import axios from "axios";

const ADMIN_BASE = "/coffee/buying-station/parchment-delivery";

// Normalize field names from frontend form → backend API
function normalizePayload(payload) {
  const out = { ...payload };
  // growerName → growersName, growerCode → growersCode
  if (out.growerName !== undefined) { out.growersName = out.growerName; delete out.growerName; }
  if (out.growerCode !== undefined) { out.growersCode = out.growerCode; delete out.growerCode; }
  if (out.grower !== undefined) { delete out.grower; }
  // netWeightWithBags → netWeightWithBag
  if (out.netWeightWithBags !== undefined) { out.netWeightWithBag = out.netWeightWithBags; delete out.netWeightWithBags; }
  // leftoverHandling → leftOverOption (map frontend values to backend enum)
  if (out.leftoverHandling !== undefined) {
    out.leftOverOption =
      out.leftoverHandling === "attach"
        ? "ATTACH_LEFTOVER"
        : out.leftoverHandling === "management"
        ? "MOVE_TO_LEFTOVER_MANAGEMENT"
        : null;
    delete out.leftoverHandling;
  }
  // Remove UI-only fields not needed by backend
  delete out.bags;
  delete out.buyingStationId;
  return out;
}

export default {
  getParchmentDeliveryList(buyingStationId, params = {}) {
    return axios
      .get(`${ADMIN_BASE}/list/${buyingStationId}`, { params })
      .then(({ data }) => data)
      .catch((err) => Promise.reject(err?.response || err));
  },

  createParchmentDelivery(payload) {
    return axios
      .post(ADMIN_BASE, normalizePayload(payload))
      .then(({ data }) => data)
      .catch((err) => Promise.reject(err?.response || err));
  },

  updateParchmentDelivery(id, payload) {
    return axios
      .put(`${ADMIN_BASE}/${id}`, normalizePayload(payload))
      .then(({ data }) => data)
      .catch((err) => Promise.reject(err?.response || err));
  },

  deleteParchmentDelivery(id) {
    return axios
      .delete(`${ADMIN_BASE}/${id}`)
      .then(({ data }) => data)
      .catch((err) => Promise.reject(err?.response || err));
  },

  getParchmentDelivery(id) {
    return axios
      .get(`${ADMIN_BASE}/${id}`)
      .then(({ data }) => data)
      .catch((err) => Promise.reject(err?.response || err));
  },

  lookupByOutturnNumbers(outturnNumbers) {
    const nums = Array.isArray(outturnNumbers) ? outturnNumbers : [outturnNumbers].filter(Boolean);
    return axios
      .post(`${ADMIN_BASE}/by-outturn-numbers`, { outturnNumbers: nums })
      .then(({ data }) => data)
      .catch((err) => Promise.reject(err?.response || err));
  },

  getParchmentDeliveryHistory(id) {
    return axios
      .get(`${ADMIN_BASE}/${id}/history`)
      .then(({ data }) => data)
      .catch((err) => Promise.reject(err?.response || err));
  },

  // Fetch processing batches for a buying station (used by add/edit dialogs)
  getProcessingBatchesForBuyingStation(buyingStationId) {
    return axios
      .get(`/coffee/buying-station/processing-batch/list/${buyingStationId}`, {
        params: { page: 1, limit: 1000 },
      })
      .then(({ data }) => data)
      .catch((err) => Promise.reject(err?.response || err));
  },

  // Bulk import parchment deliveries — upserts each record by outturn number
  bulkImportParchmentDeliveries(records) {
    return axios
      .post(`${ADMIN_BASE}/bulk-import`, { records })
      .then(({ data }) => data)
      .catch((err) => Promise.reject(err?.response || err));
  },

  // Bulk import with file upload — sends FormData containing file + records JSON string
  bulkImportWithFile(formData) {
    return axios
      .post(`${ADMIN_BASE}/bulk-import`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then(({ data }) => data)
      .catch((err) => Promise.reject(err?.response || err));
  },

  // List bulk import history for the org
  getBulkImportHistory(params = {}) {
    return axios
      .get(`${ADMIN_BASE}/bulk-import/history`, { params })
      .then(({ data }) => data)
      .catch((err) => Promise.reject(err?.response || err));
  },
};
